const Footer = () => {
    return (
        <section id='footer'>
            <div className='footer container'>
                <div className='brand'>
                    <h1>
                        <span>S</span>olomon <span>N</span>jobvu
                    </h1>
                    <h2>Web and App Developer</h2>
                    <div className='social-icon'>
                        <div className='social-item'>
                            <a
                                href='https://web.facebook.com/S.Njobvu1/'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <box-icon
                                    animation='burst-hover'
                                    color='rgba(219, 233, 241, 0.925)'
                                    size='lg'
                                    type='logo'
                                    name='facebook-circle'
                                ></box-icon>
                            </a>
                        </div>

                        <div className='social-item'>
                            <a
                                href='https://www.twitter.com/iam_njobvu'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <box-icon
                                    animation='burst-hover'
                                    color='rgba(219, 233, 241, 0.925)'
                                    size='lg'
                                    name='twitter'
                                    type='logo'
                                ></box-icon>
                            </a>
                        </div>

                        <div className='social-item'>
                            <a
                                href='https://www.linkedin.com/in/solomonnjobvu'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <box-icon
                                    animation='burst-hover'
                                    color='rgba(219, 233, 241, 0.925)'
                                    size='lg'
                                    name='linkedin-square'
                                    type='logo'
                                ></box-icon>
                            </a>
                        </div>

                        <div className='social-item'>
                            <a
                                href='https://www.instagram.com/namzsolomon'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <box-icon
                                    animation='burst-hover'
                                    size='lg'
                                    color='rgba(219, 233, 241, 0.925)'
                                    type='logo'
                                    name='instagram'
                                ></box-icon>
                            </a>
                        </div>

                        <div className='social-item'>
                            <a
                                href='https://dev.to/thisissolomon'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <box-icon
                                    animation='burst-hover'
                                    color='rgba(219, 233, 241, 0.925)'
                                    size='lg'
                                    type='logo'
                                    name='dev-to'
                                ></box-icon>
                            </a>
                        </div>

                        <div className='social-item'>
                            <a
                                href='https://www.github.com/thisis-Solomon'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <box-icon
                                    animation='burst-hover'
                                    size='lg'
                                    color='rgba(219, 233, 241, 0.925)'
                                    type='logo'
                                    name='github'
                                ></box-icon>
                            </a>
                        </div>

                        <div className='socail-item'>
                            <a
                                href='https://'
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                <box-icon
                                    animation='burst-hover'
                                    color='rgba(219, 233, 241, 0.925)'
                                    size='lg'
                                    name='whatsapp'
                                    type='logo'
                                ></box-icon>
                            </a>
                        </div>
                    </div>
                    <p> built in reactjs by Solomon ©2021.</p>
                </div>
            </div>
        </section>
    );
};

export default Footer;
